var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBulb = function SvgBulb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 23.7188V26.8125C20.625 27.3595 20.4077 27.8841 20.0209 28.2709C19.6341 28.6577 19.1095 28.875 18.5625 28.875H14.4375C13.8905 28.875 13.3659 28.6577 12.9791 28.2709C12.5923 27.8841 12.375 27.3595 12.375 26.8125V23.7188",
    stroke: "url(#paint0_linear_510_510)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.03125V3.09375",
    stroke: "url(#paint1_linear_510_510)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 15.4688H4.125",
    stroke: "url(#paint2_linear_510_510)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 5.15625L6.66875 6.60963",
    stroke: "url(#paint3_linear_510_510)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9375 15.4688H28.875",
    stroke: "url(#paint4_linear_510_510)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8436 5.15625L26.3311 6.60963",
    stroke: "url(#paint5_linear_510_510)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2579 23.7188H20.7416C22.2737 22.9583 23.5597 21.7803 24.4513 20.3206C25.3429 18.861 25.8039 17.179 25.781 15.4688C25.7376 13.0208 24.7458 10.6852 23.0145 8.95396C21.2833 7.22272 18.9477 6.23093 16.4998 6.1875C14.0509 6.23097 11.7145 7.22352 9.98309 8.95594C8.2517 10.6884 7.26053 13.0253 7.21851 15.4742C7.19669 17.1836 7.65813 18.8644 8.54969 20.323C9.44124 21.7816 10.7267 22.9587 12.2579 23.7188V23.7188Z",
    stroke: "url(#paint6_linear_510_510)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 28.875V31.9688",
    stroke: "url(#paint7_linear_510_510)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18.5625V23.7188",
    stroke: "url(#paint8_linear_510_510)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4062 15.4688L16.5 18.5625L19.5938 15.4688",
    stroke: "url(#paint9_linear_510_510)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_510_510",
    x1: 20.625,
    y1: 26.3378,
    x2: 12.375,
    y2: 26.3378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_510_510",
    x1: 17.5,
    y1: 2.07887,
    x2: 16.5,
    y2: 2.07887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_510_510",
    x1: 4.125,
    y1: 15.9767,
    x2: 2.0625,
    y2: 15.9767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_510_510",
    x1: 6.66875,
    y1: 5.89447,
    x2: 5.15625,
    y2: 5.89447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_510_510",
    x1: 30.9375,
    y1: 15.9767,
    x2: 28.875,
    y2: 15.9767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_510_510",
    x1: 27.8436,
    y1: 5.89447,
    x2: 26.3311,
    y2: 5.89447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_510_510",
    x1: 25.7818,
    y1: 15.0923,
    x2: 7.21777,
    y2: 15.0923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_510_510",
    x1: 17.5,
    y1: 30.4464,
    x2: 16.5,
    y2: 30.4464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_510_510",
    x1: 17.5,
    y1: 21.1815,
    x2: 16.5,
    y2: 21.1815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_510_510",
    x1: 19.5938,
    y1: 17.0402,
    x2: 13.4063,
    y2: 17.0402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBulb);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";